import React from 'react';
import {Flex} from '@priority-software/priority-style-react';
import styles from '../styles/ReportsDialog.module.scss';
import TypeCard from '../../../components/Common/ActionCard/ActionCard';
import {ReportDialogOption} from '../types';

export const ReportOptions = ({options, selectedOption, chooseOption}) => {
    const isOptionSelected = (option: ReportDialogOption): boolean => {
        return selectedOption.mode === option.mode;
    };

    const shownOptions = options.filter(item => !item.hide);
    return (
        <Flex justifyContent="flex-start">
            {shownOptions.map((option, idx) => {
                return (
                    <TypeCard
                        key={idx}
                        componentClasses={idx < options.length - 1 ? styles.marginTypeCard : null}
                        tooltip={option.tooltip}
                        icon={option.icon}
                        title={option.title}
                        isSelected={isOptionSelected(option)}
                        onClick={() => chooseOption(option)}
                    />
                );
            })}
        </Flex>
    );
};
